import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import DashboardLayout from "./layout/DashboardLayout";
import Login from "./pages/login";
import ForgotPassword from "./pages/forgot-password";
import ResetPassword from "./pages/reset-password";
import Dashboard from "./pages/dashboard";
import Profile from "./pages/profile";
import Publications from "./pages/publications";
import Dossiers from "./pages/dossiers";
import ShowDossier from "./pages/dossiers/show";
import VerifyDocument from "./pages/verify";

function App() {
    const isAuthenticated = true; // TODO: gérer avec un vrai state

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/verifier" element={<VerifyDocument />} />

                <Route
                    path="/dashboard"
                    element={
                        isAuthenticated ? (
                            <DashboardLayout />
                        ) : (
                            <Navigate to="/login" replace />
                        )
                    }
                >
                    <Route index element={<Dashboard />} />
                    <Route path="dossiers" element={<Dossiers />} />
                    <Route path="administration/publications" element={<Publications />} />
                    <Route path="profile" element={<Profile />} />
                    <Route path="dossiers/:code/show" element={<ShowDossier />} />
                </Route>

                {/* Redirection par défaut */}
                <Route path="*" element={<Navigate to="/login" replace />} />

            </Routes>
        </BrowserRouter>
    );
}

export default App;
